import React from "react"

export default function Edit() {
   return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M19.0649 2.21622C18.3954 1.54698 17.3103 1.54698 16.6408 2.21622L3.4286 15.4285L1.71428 22.2857L8.57155 20.5714L21.7838 7.35917C22.453 6.68973 22.453 5.60457 21.7838 4.93513L19.0649 2.21622Z" fill="#5B5E71" />
      </svg>
   )
}